"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KeyboardEventCodeEnum;
(function (KeyboardEventCodeEnum) {
    KeyboardEventCodeEnum["ARROW_UP"] = "ArrowUp";
    KeyboardEventCodeEnum["ARROW_DOWN"] = "ArrowDown";
    KeyboardEventCodeEnum["ENTER"] = "Enter";
    KeyboardEventCodeEnum["ESCAPE"] = "Escape";
    KeyboardEventCodeEnum["Y"] = "Y";
})(KeyboardEventCodeEnum || (KeyboardEventCodeEnum = {}));
exports.default = KeyboardEventCodeEnum;
